import {
  FetchState,
} from "@/shared/types";
import {
  InstantTransferFailureRequest,
  InstantTransferPageResponseModel,
  InstantTransferFailureState,
  EmploymentStatusResponse,
  InstantTransferFailureDetailModel
} from "@/admin/types";
import * as BankService from "@/shared/api/bankService";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";

export const initialState: InstantTransferFailureState = {
    listFetchState: FetchState.Uninitialized,
    itemFetchState: FetchState.Uninitialized,
    pageNumber: -1,
    numberOfPages: -1,
    totalCount: -1,
    items: null,
    transactionId: null,
    detailItem: null,
    filters: null,
  };

export const useInstantTransactionFailureStore = defineStore("instantTransactionFailure", {
  state: (): InstantTransferFailureState => (_.cloneDeep(initialState)),
  getters: {
    isListLoaded: state => state.listFetchState === FetchState.Loaded,
    isDetailLoaded: state => state.itemFetchState === FetchState.Loaded,
    getLoadedItems: state => state.items,
    pageRange: state => _.range(1, state.numberOfPages + 1),
    storedFilter: state => state.filters,
  },
  actions: {
    setItems (args: { page: number, data: InstantTransferPageResponseModel }) {
      this.items = args.data.items;
      this.pageNumber = args.data.pageNumber;
      this.numberOfPages = args.data.numberOfPages;
      this.totalCount = args.data.totalCount;
      this.listFetchState = args.data.items ? FetchState.Loading : FetchState.Loaded;
    },
    setItem ( data: InstantTransferFailureDetailModel) {
      this.detailItem = data;
    },
    setListFetchState ( fetchState: FetchState) {
      this.listFetchState = fetchState;
    },
    setItemFetchState ( fetchState: FetchState) {
      this.itemFetchState = fetchState;
    },
    setTransactionId ( transactionId: string) {
      this.transactionId = transactionId;
    },
    setEmploymentStatus ( data: EmploymentStatusResponse) {
      if (this.detailItem) {
        this.detailItem.employmentStatus = data.employmentStatus;
      }
    },
    removeFromListById ( transactionId) {
      this.items.splice(this.items.findIndex(item => item.transactionId === transactionId), 1);
    },
    setFilters ( filters: InstantTransferFailureRequest) {
      this.filters = {...filters};
    },
    setFiltersFromStorage () {
      this.filters = JSON.parse(localStorage.getItem("instantTranscationFailureFilters"));
    },
    storeFiltersInStorage ( request: InstantTransferFailureRequest) {
      this.setFilters( request);
    },
    loadItems (request: InstantTransferFailureRequest) {
      if (this.pageNumber === request.pageNumber && this.listFetchState === FetchState.Loading) {
        return Promise.resolve();
      }
      this.setListFetchState( FetchState.Loading);
      this.setFilters(request);
      localStorage.setItem("instantTranscationFailureFilters", JSON.stringify(request));
      return BankService.getInstantTransferFailuresNew(request)
        .then(v => {
          this.setItems( { page: request.pageNumber, data: v.data});
          this.setListFetchState( FetchState.Loaded);
        })
        .catch(err => {
          this.setListFetchState( FetchState.Loaded);
          return storeHelper.handleError({error: err, rethrow: true});
        });
    },
    resolveById ( transactionId) {
      if (this.transactionId === transactionId && this.itemFetchState === FetchState.Loading) {
        return Promise.resolve();
      }
      this.setItemFetchState( FetchState.Loading);
      this.setTransactionId( transactionId);
      return BankService.resolveInstantTransferFailure(transactionId)
      .then(v => {
        this.setItem( v.data);
        this.setItemFetchState( FetchState.Loaded);
      })
      .catch(err => {
        this.setItemFetchState( FetchState.Loaded);
        return storeHelper.handleError({error: err, rethrow: true});
      });
    },
    retryById ( transactionId) {
      if (this.transactionId === transactionId && this.itemFetchState === FetchState.Loading) {
        return Promise.resolve();
      }
      this.setItemFetchState( FetchState.Loading);
      this.setTransactionId( transactionId);
      return BankService.retryInstantTransferFailure(transactionId)
      .then(v => {
        this.setItem( v.data);
        this.setItemFetchState( FetchState.Loaded);
      })
      .catch(err => {
        this.setItemFetchState( FetchState.Loaded);
        return storeHelper.handleError({error: err, rethrow: true});
      });
    },
    loadDetailById ( transactionId) {
      if (this.transactionId === transactionId && this.itemFetchState === FetchState.Loading) {
        return Promise.resolve();
      }
      this.setTransactionId( transactionId);
      this.setItemFetchState( FetchState.Loading);
      return BankService.getInstantTransferFailureDetail(transactionId)
      .then(v => {
        this.setItem( v.data);
        this.setItemFetchState( FetchState.Loaded);
      })
      .catch(err => {
        this.setItemFetchState( FetchState.Loaded);
        return storeHelper.handleError({error: err, rethrow: true});
      });
    },
    getEmploymentStatus ( cognitoUsername) {
      return UserService.getEmploymentStatus(cognitoUsername)
        .then(r => {
          this.setEmploymentStatus( r.data);
        })
        .catch(err => {
          return storeHelper.handleError({error: err, rethrow: true});
        });
      }
  }});